import * as z from "zod";
import { makeReportDateFilterSchema } from "./base-report-date-filter";
import { ReportFilterType } from "./report-filter-type";

export const ApprovalDateFilterSchema = makeReportDateFilterSchema(
  ReportFilterType.RETURN_APPROVAL_DATE,
);

export type ApprovalDateFilter = z.infer<typeof ApprovalDateFilterSchema>;
